import { deprecateNotification as sendDeprecateNotification } from '@/libs/functions.js'

// Emits a developer warning when the backend marks an endpoint as deprecated.
export function notifyDeprecatedEndpoint(response) {
  const target = response.config.url
  const message = response.headers.get('X-Deprecated')

  sendDeprecateNotification(target, message)

  return response
}
